import { Ouvrage } from './ouvrage.model';

export class ListOuvrage {
    constructor(public ouvrages?:Ouvrage[]){}
}